import React, { useState } from 'react'
 
 
import FarmerPurchaseList from './FarmerPurchaseList';
import FarmerPurchaseForm from './FarmerPurchaseForm';

const FarmerPurchase= () => {
    const [fromIsShown, setFromIsShown] = useState(false);
    const [upData, setUpData] = useState(false);
    const [serviceId, setServiceId] = useState("none");


  return (
    <>
      {fromIsShown ? (
          <FarmerPurchaseForm addForm={setFromIsShown} update={upData} sId={serviceId} />
        ) : (
          <FarmerPurchaseList addForm={setFromIsShown} update={setUpData} sId={setServiceId}/>
        )}  
    </>
  )
}

export default FarmerPurchase